import common from './common.json';
import estacio from './estacio.json';
import ibmec from './ibmec.json';
import idomed from './idomed.json';
import wyden from './wyden.json';

const brands = { common, wyden, ibmec, estacio, idomed };

const brandsList = Object.keys(brands);

export { brands, brandsList };
